import { UserRegistrationForm } from "../types/userRegistrationForm";

import getAuthQueryParamData from "./getAuthQueryParamData";
import selectParams from "./selectParams";

const emptyUserRegistrationForm: UserRegistrationForm = {
  username: "",
  firstName: "",
  lastName: "",
  preferredName: "",
  email: "",
  password: "",
  passwordConfirmation: "",
  groupIds: [],
};

const getDefaultUserRegistrationData = (): UserRegistrationForm => {
  return {
    ...emptyUserRegistrationForm,
    ...selectParams(getAuthQueryParamData(), [
      "firstName",
      "lastName",
      "email",
    ]),
  };
};

export default getDefaultUserRegistrationData;
